import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { passwordSet } from 'store/modules/user/actions';

import Component from './component';

const mapDispatchToProps = (dispatch: Dispatch): object => {
    return {
        actions: {
            passwordSet: bindActionCreators(passwordSet, dispatch),
        },
    };
};

Component.defaultProps = {
    onSuccess: null,
};
export default connect(null, mapDispatchToProps)(Component);
